import React, { useEffect, useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { useClient } from '../ClientContext';

export function RoleRedirect() {
  const { user } = useAuth0();
  const { config } = useClient();
  const userRoles = user ? user[process.env.REACT_APP_AUTH0_ROLE_CLAIMS] || [] : [];
  const map = useMemo(() => (config && config.roleRedirectMap) || {}, [config]);
  const matchedRole = useMemo(() => userRoles.find((role) => Boolean(map[role])), [map, userRoles]);
  const redirectTo = matchedRole ? map[matchedRole] : '/access-denied';
  const hasAdminRole = userRoles.includes('Admin');

  useEffect(() => {
    if (!config || hasAdminRole || !matchedRole || redirectTo.startsWith('/')) {
      return;
    }

    window.location.replace(redirectTo);
  }, [config, hasAdminRole, matchedRole, redirectTo]);

  if (!config) {
    return null;
  }

  if (hasAdminRole) {
    return <Navigate to="/admin" replace />;
  }

  if (!matchedRole) {
    return <Navigate to="/access-denied" replace />;
  }

  if (redirectTo.startsWith('/')) {
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="body1">Routing to your dashboard...</Typography>
    </Box>
  );
}

export default RoleRedirect;
